(function () {
  if (window.__pcCardSwiperV5) return;
  window.__pcCardSwiperV5 = true;

  function init(root) {
    root = root || document;
    if (!window.Swiper) return false;

    var els = root.querySelectorAll
      ? root.querySelectorAll('[data-pc-swiper]:not([data-pc-swiper-inited])')
      : [];

    els.forEach(function (el) {
      // Если вдруг кто-то уже инициализировал Swiper на этом элементе
      if (el.classList.contains('swiper-initialized') || el.swiper) {
        el.setAttribute('data-pc-swiper-inited', '1');
        return;
      }

      el.setAttribute('data-pc-swiper-inited', '1');

      var prev = el.querySelector('[data-pc-swiper-prev]');
      var next = el.querySelector('[data-pc-swiper-next]');

      function setDisabled(btn, disabled) {
        if (!btn) return;
        btn.classList.toggle('is-disabled', !!disabled);
        btn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
        // НЕ ставим disabled="", чтобы клик не проваливался в ссылку товара
      }

      function sync(sw) {
        var locked = !!sw.isLocked;
        setDisabled(prev, locked || sw.isBeginning);
        setDisabled(next, locked || sw.isEnd);
      }

      var sw = new Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 0,
        watchOverflow: true,

        // ✅ на ПК мышью не тянем, но на мобиле свайп работает
        simulateTouch: false,
        grabCursor: false,

        // ✅ важно для динамически вставленных секций (related-products)
        observer: true,
        observeParents: true,
        observeSlideChildren: true,

        preventClicks: true,
        preventClicksPropagation: true,
        touchStartPreventDefault: false,

        navigation: {
          prevEl: prev,
          nextEl: next,
          disabledClass: 'is-disabled'
        },

        on: {
          init: function () { sync(this); },
          slideChange: function () { sync(this); },
          toEdge: function () { sync(this); },
          fromEdge: function () { sync(this); },
          resize: function () { sync(this); },
          lock: function () { sync(this); },
          unlock: function () { sync(this); }
        }
      });

      // гасим клики по disabled-стрелкам, чтобы не проваливались на товар
      function blockIfDisabled(e) {
        var btn = e.currentTarget;
        if (!btn.classList.contains('is-disabled')) return;
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      }
      if (prev) prev.addEventListener('click', blockIfDisabled, true);
      if (next) next.addEventListener('click', blockIfDisabled, true);

      sync(sw);

      // иногда после вставки DOM нужно обновить размеры
      setTimeout(function(){ sw.update(); sync(sw); }, 50);
      setTimeout(function(){ sw.update(); sync(sw); }, 250);
    });

    return true;
  }

  // --- Init with retry (если Swiper грузится defer) ---
  function initWithRetry(root) {
    var tries = 0;
    function tick() {
      tries += 1;
      if (init(root) || tries >= 30) return; // ~3 секунды
      setTimeout(tick, 100);
    }
    tick();
  }

  // --- MutationObserver: ловим динамически вставленный related-products ---
  var scheduled = false;
  function scheduleInit(target) {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      initWithRetry(target || document);
    });
  }

  function startObserver() {
    if (window.__pcCardSwiperObserver) return;
    window.__pcCardSwiperObserver = true;

    var obs = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (!m.addedNodes || !m.addedNodes.length) continue;

        for (var j = 0; j < m.addedNodes.length; j++) {
          var node = m.addedNodes[j];
          if (!node || node.nodeType !== 1) continue;

          // если добавили кусок с нашими слайдерами — переинициализируем
          if (
            node.matches?.('[data-pc-swiper]') ||
            node.querySelector?.('[data-pc-swiper]')
          ) {
            scheduleInit(node);
            return;
          }
        }
      }
    });

    obs.observe(document.body, { childList: true, subtree: true });
  }

  // --- старт ---
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initWithRetry(document);
      startObserver();
    });
  } else {
    initWithRetry(document);
    startObserver();
  }

  // В Theme Editor
  document.addEventListener('shopify:section:load', function (e) { initWithRetry(e.target); });
  document.addEventListener('shopify:section:reorder', function () { initWithRetry(document); });
})();